const UIStrategy = require('./ui_strategy');

class UIStrategyPending extends UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        super(bookingInfo, view, templates, keys, constants);
    }

    getData() {
        const parentData = super.getData();
        return Odigeo._.merge({}, parentData, {
            parent: {
                base: {
                    status: {
                        box: {
                            classes: this.CONST.informativeStatusBoxClasses,
                        },
                        message: {
                            text: this.keys.statusMessagePending,
                        },
                        icon: {
                            classes: this.CONST.informativeStatusIconClasses,
                        },
                    },
                },
            },
        });
    }
}

module.exports = UIStrategyPending;
